import App from './App.svelte';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;